import fetchService from '../../services/api/fetch-dimensions'
import { useQuery } from 'react-query'

const useItems = () => {
    const { data, isLoading } = useQuery('dimensions', fetchService, { staleTime: 86400000, cacheTime: 86400000 })
    return [
        data || [],
        {
            isLoading
        },
    ]
}

export default useItems